import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-patient-photos-consented-tab',
  templateUrl: './patient-photos-consented-tab.component.html',
  styleUrls: ['./patient-photos-consented-tab.component.less'],
})
export class PatientPhotosConsentedTabComponent implements OnDestroy {
  unsub: Subject<void> = new Subject<void>();
  constructor() {}

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
